module.exports = __webpack_public_path__ + "img/caseBuilder-dentist.4f0f9734.webp";